import { Injectable, inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';

type HeapWindow = typeof WA_WINDOW & {
  // this is optional because it can be blocked
  heap?: {
    addUserProperties: (x: unknown) => void;
    resetIdentity: () => void;
    identify: (id: unknown) => void;
    addEventProperties: (x: unknown) => void;
    // The following exist by i am not sure of their signatures. If you need them, please updat them
    init: (...args: unknown[]) => void;
    startTracking: (...args: unknown[]) => void;
    stopTracking: (...args: unknown[]) => void;
    identifyHashed: (...args: unknown[]) => void;
    getSessionId: (...args: unknown[]) => void;
    getUserId: (...args: unknown[]) => void;
    getIdentity: (...args: unknown[]) => void;
    removeEventProperty: (...args: unknown[]) => void;
    clearEventProperties: (...args: unknown[]) => void;
    addAccountProperties: (...args: unknown[]) => void;
    addAdapter: (...args: unknown[]) => void;
    addTransformer: (...args: unknown[]) => void;
    addTransformerFn: (...args: unknown[]) => void;
    onReady: (...args: unknown[]) => void;
    addPageviewProperties: (...args: unknown[]) => void;
    removePageviewProperty: (...args: unknown[]) => void;
    clearPageviewProperties: (...args: unknown[]) => void;
    trackPageview: (...args: unknown[]) => void;
  };
};

@Injectable({
  providedIn: 'root',
})
export class HeapService {
  private readonly window = inject<HeapWindow>(WA_WINDOW);

  public addUserProperties(properties: Record<string, unknown>) {
    // https://developers.heap.io/docs/using-identify#when-and-where-to-call-identify-and-adduserproperties
    this.window.heap?.addUserProperties(properties);
  }

  public resetIdentity(): void {
    this.window.heap?.resetIdentity();
  }

  public identify(id: unknown): void {
    this.window.heap?.identify(id);
  }

  public addEventProperties(properties: Record<string, unknown>) {
    this.window.heap?.addEventProperties(properties);
  }
}
